import React, { HTMLAttributes } from 'react';
import c from 'classnames';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import {
  ImmutableEntity,
} from '@uncinc/react-drupal-core/types';

import { Text } from '../../../components';

import './style.scss';
import { ParagraphText as Type } from '../../../types/uncinc_profile/paragraphs';

interface ParagraphTextProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<Type>;
}

const ParagraphText: React.FC<ParagraphTextProps> = ({
  entity,
}) => {
  const paragraphText = entity.toJS();

  const uuid = paragraphText.uuid[0].value;
  const title = paragraphText.field_title[0]?.value;
  const background = paragraphText.field_background[0]?.value;
  const body = paragraphText.field_body[0].processed || '';
  const link = paragraphText.field_link?.[0];
  const linkTitle = link?.title;
  const linkUri = link?.alias || link?.uri;
  const linkTarget = link?.options?.attributes?.target;
  const secondaryLink = paragraphText.field_link_secondary?.[0];
  const secondaryLinkTitle = secondaryLink?.title;
  const secondaryLinkUri = secondaryLink?.alias || secondaryLink?.uri;
  const secondaryLinkTarget = secondaryLink?.options?.attributes?.target;

  const classes = c('ParagraphText', {
    'ParagraphText--with-background': background,
  });

  return (
    <div id={uuid} className={classes}>
      <Container>
        <Text
          title={title}
          text={body}
          link={linkUri}
          linkText={linkTitle}
          target={linkTarget}
          secondaryLink={secondaryLinkUri}
          secondaryLinkText={secondaryLinkTitle}
          secondaryLinkTarget={secondaryLinkTarget}
        />
      </Container>
    </div>
  );
};

export default ParagraphText;
